import moment from 'moment';
import isSameYear from 'date-fns-old/is_same_year';
import { formatDateByYear } from '../../../utils/converters/dateConverters';
import {
  FULL_SHORT_DATE_PATTERN,
  SHORT_DATE_PATTERN,
} from '../../../constants/strings';

const handleExpirationTime = (date, dueDescription, formatMessage) => {
  const now = moment();
  const expiredDate = moment(date);
  const isExpired = expiredDate.isBefore(now);
  if (isExpired) return formatMessage({ id: 'task.overdue' });
  if (dueDescription) return dueDescription;

  return moment(date).calendar(null, {
    sameDay: `[${formatMessage({ id: 'task.dueToday' })}]`,
    nextDay: `[${formatMessage({ id: 'task.dueTomorrow' })}]`,
    nextWeek: formatMessage({ id: SHORT_DATE_PATTERN.id }),
    sameElse: isSameYear(date, new Date())
      ? formatMessage(SHORT_DATE_PATTERN)
      : formatMessage(FULL_SHORT_DATE_PATTERN),
  });
};

export const timeToShow = (
  completedTime,
  expiredTime,
  dueDescription,
  formatMessage,
) => {
  const completedDate = completedTime
    ? formatDateByYear(completedTime, formatMessage)
    : null;
  const expiredDate = expiredTime
    ? handleExpirationTime(expiredTime, dueDescription, formatMessage)
    : null;
  return completedDate || expiredDate;
};

export const handleElectronicConsentExpirationTime = (
  date,
  formatMessage,
  isTaskCompleted,
) => {
  if (isTaskCompleted) {
    return formatDateByYear(date, formatMessage);
  }

  const now = moment();
  const expiredDate = moment(date);
  const isExpired = expiredDate.isBefore(now);
  if (isExpired) return formatMessage({ id: 'task.overdue' });

  const parsedDate = moment(date);

  const isToday = parsedDate.isSame(moment(), 'day');

  const isTomorrow = parsedDate.isSame(moment().add(1, 'day'), 'day');

  if (!isToday && !isTomorrow) {
    return `Due ${formatDateByYear(date, formatMessage)}`;
  }

  return moment(date).calendar(null, {
    sameDay: `[${formatMessage({ id: 'task.dueToday' })}]`,
    nextDay: `[${formatMessage({ id: 'task.dueTomorrow' })}]`,
  });
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/handleTaskTime.js